

export class ReportRepository {

    private httpService: IHttpService;

    constructor(instance: IHttpService) {
        this.httpService = instance;
    }

    async getExtraReport(userId: number, profileId: number): Promise<ExtraReportUser> {
        const response = await this.httpService.get<Data<ExtraReportUser>>(`/v1/extra_report_user/${userId}/${profileId}`);
        return response.data;
    }

    async updateExtraReport(id: number, data: {
            ids_to_add: { report_id: number; is_aggregation: boolean; }[];
            ids_to_remove: number[];
    }): Promise<number> {
        const response = await this.httpService.patch<APIResponse<null>, { user_id: number; profile_id: number; }[]>(`/v1/extra_report_user/${id}`, { data });
        return response.result.length;
    }
}
